import { FC } from 'react';
import {
    Box,
    Flex,
    HStack,
    IconButton,
    Image,
    Text,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import WhatsAppButton from '../WhatsAppButton/WhatsAppButton';
import SidebarMenu from '../SideBarMenu/SideBarMenu';
import AnimatedLink from './AnimatedLink/AnimatedLink';

interface NavBarProps {
    active: string;
    onNavigate?: (id: string) => void;
}

const NavBar: FC<NavBarProps> = ({ active, onNavigate }) => {
    const menuItems = [
        { label: 'Home', href: 'home' },
        { label: 'Sobre Nós', href: 'about' },
        { label: 'Artesanatos', href: 'products' },
        { label: 'Contato', href: 'contact' },
    ];

    return (
        <div className="NavBar" data-testid="NavBar">
            <Box
                position="fixed"
                top={0}
                width="100%"
                height="80px"
                zIndex="999"
                bg="white"
                px={8}
                py={4}
                boxShadow="md"
                display={{ base: 'none', md: 'flex' }}
            >
                <Flex
                    alignItems="center"
                    justifyContent="center"
                    gap={12}
                    flexWrap="wrap"
                    w="100%"
                >
                    <Image
                        src={require("../../assets/img/logo-donna-cegonha.png")}
                        alt="Logo Donna Cegonha"
                        objectFit="contain"
                        w="50px"
                        h="50px"
                    />

                    <HStack spacing={6}>
                        {menuItems.map(({ label, href }) => (
                            <Box
                                key={label}
                                cursor="pointer"
                                onClick={() => onNavigate?.(href)}
                            >
                                <AnimatedLink to={href} isActive={active === href}>
                                    {label}
                                </AnimatedLink>
                            </Box>
                        ))}
                    </HStack>

                    <HStack spacing={4}>
                        <WhatsAppButton />
                        <IconButton
                            as="a"
                            href="https://www.instagram.com/donna.cegonha_/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                            icon={<FontAwesomeIcon icon={faInstagram} style={{ fontSize: '24px' }} />}
                            color="color.500"
                            bg="transparent"
                            _hover={{ color: 'color.600' }}
                            _active={{ bg: 'none' }}
                        />
                    </HStack>
                </Flex>
            </Box>

            <Box display={{ base: 'flex', md: 'none' }}>
                <SidebarMenu active={active} menuItems={menuItems} onNavigate={onNavigate} />
            </Box>
        </div>
    );
};

export default NavBar;
